export const POLICY_TYPES = [
  'WC',
  'GL',
  'Auto',
  'Umbrella',
  'Inland Marine',
  'EPLI',
  'Crime',
  'Drone',
  'Flood',
  'BR',
  'New Type',
];

export const BILLING_TYPES = ['Monthly', 'Quarterly', 'Yearly'];
